import { useState, useEffect } from 'react';
import { Link, useLocation } from 'react-router-dom';
import { motion, AnimatePresence } from 'framer-motion';
import { Menu, X } from 'lucide-react';

const LOGO_URL = "https://customer-assets.emergentagent.com/job_77c7e095-6aee-4db7-89db-d1905485427a/artifacts/rg0086kf_Untitled%20design%20%283%29.png";

export const Header = () => {
  const [scrolled, setScrolled] = useState(false);
  const [mobileMenuOpen, setMobileMenuOpen] = useState(false);
  const location = useLocation();
  const isHome = location.pathname === '/';

  useEffect(() => {
    const handleScroll = () => {
      setScrolled(window.scrollY > 50);
    };

    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  useEffect(() => {
    setMobileMenuOpen(false);
  }, [location]);

  const navLinks = [
  { to: '/about', label: 'About' },
  { to: '/services', label: 'Services' },
  { to: '/projects', label: 'Projects' },
  { to: '/contact', label: 'Contact' }];


  return (
    <>
      <header
        data-testid="header"
        className={`fixed top-0 left-0 right-0 z-50 transition-all duration-500 ${
        scrolled || !isHome ?
        'bg-white/98 backdrop-blur-md border-b border-stone-100' :
        'bg-transparent'}`
        }>

        <nav className="flex items-center justify-between h-20 md:px-12 lg:px-24 !font-['Georgia'] !font-semibold !text-sm !text-center !my-[5px] !mx-[5px] !pl-[50px] !pr-[50px] !gap-[.5px] !rounded-[1000px] !shadow-2xl">
          {/* Left - Logo */}
          <div className="flex items-center site-logo">
            <Link
              to="/"
              data-testid="logo-link"
              className="flex items-center">

              <motion.img
                src={LOGO_URL}
                alt="biomstudio"
                className="h-28 md:h-32 w-auto object-contain mix-blend-multiply"
                whileHover={{ scale: 1.05 }}
                whileTap={{ scale: 0.95 }}
                transition={{ duration: 0.3, ease: [0.22, 1, 0.36, 1] }} />

            </Link>
          </div>

          {/* Right - Navigation */}
          <div className="hidden md:flex items-center gap-8">
            {navLinks.map((link) =>
            <Link
              key={link.to}
              to={link.to}
              data-testid={`nav-${link.label.toLowerCase()}`}
              className={`font-manrope text-xs uppercase tracking-[0.2em] font-medium transition-colors duration-300 hover:opacity-70 ${
              scrolled || !isHome ? 'text-stone-900' : 'text-white'} ${
              location.pathname === link.to ? 'border-b border-current' : ''}`}>

                {link.label}
              </Link>
            )}
          </div>

          {/* Mobile Menu Button */}
          <div className="flex md:hidden">
            <button
              data-testid="mobile-menu-toggle"
              onClick={() => setMobileMenuOpen(!mobileMenuOpen)}
              className={`p-2 transition-colors duration-300 ${
              scrolled || !isHome ? 'text-stone-900' : 'text-white'}`
              }
              aria-label={mobileMenuOpen ? 'Close menu' : 'Open menu'}>

              {mobileMenuOpen ? <X size={24} /> : <Menu size={24} />}
            </button>
          </div>
        </nav>
      </header>

      {/* Mobile Menu */}
      <AnimatePresence>
        {mobileMenuOpen &&
        <motion.div
          initial={{ opacity: 0, y: -20 }}
          animate={{ opacity: 1, y: 0 }}
          exit={{ opacity: 0, y: -20 }}
          transition={{ duration: 0.3 }}
          className="fixed inset-0 z-40 bg-white pt-24"
          data-testid="mobile-menu">

            <nav className="flex flex-col items-center gap-8 py-12">
              {navLinks.map((link, index) =>
            <motion.div
              key={link.to}
              initial={{ opacity: 0, y: 20 }}
              animate={{ opacity: 1, y: 0 }}
              transition={{ delay: index * 0.1 }}>

                  <Link
                to={link.to}
                data-testid={`mobile-nav-${link.label.toLowerCase()}`}
                className={`font-manrope text-2xl font-light tracking-wide text-stone-900 hover:text-stone-500 transition-colors duration-300 ${
                location.pathname === link.to ? 'border-b-2 border-stone-900' : ''}`
                }>

                    {link.label}
                  </Link>
                </motion.div>
            )}
            </nav>
          </motion.div>
        }
      </AnimatePresence>
    </>);

};